// extracted by mini-css-extract-plugin
export default {"CarCharge":"CarCharge_CarCharge__21Yxo","CarCharge__new":"CarCharge_CarCharge__new__tXukh","CarCharge__table":"CarCharge_CarCharge__table__wMMrE"};